//import { IStatsBeatConfig } from "./IStatsBeat";
"use strict";
export {};
//# sourceMappingURL=IConfiguration.js.map